// Warranty registration
    $("input").change(function(){
        if ($(this).attr('name')=='serialNumber'){
            console.log("1");
            $("input[name='serialNumber']").attr("title", "Ex. AB5C20D412-01141").attr("pattern","^\w{10}\-\d{5}$");

        }
    });

// News Section Hover
    $(".news-icons-list__item").hover(function(){
        $(this).children().css("color", "#2db2fa");
    }, function(){
        $(this).children().css("color", "#0b0b0b");
    });
// Structure Section Hover
    $(".structure-img__numbers .number").hover(function(){
        $(".structure-img__numbers .number").removeClass("active");
        $(this).addClass("active");
    }, function(){
        $(this).removeClass("active");
    });

    $(".hover-underline-animation").hover(function(){
        var index = $(".hover-underline-animation").index($(this));
        console.log("Hovering...", index)
        $(".structure-img__numbers .number").each(function(i){
            if (i==index){
                $(this).addClass("active");
            }
            else{
                $(this).removeClass("active");
            }
        })
    }, function(){
        $(".structure-img__numbers .number").removeClass("active");
    });

// Structure slider on mobile
    if (screen.width <767){
        $("section#structure .structure-list").addClass("slick-slider");
    }
    $('.structure-list').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        console.log(nextSlide);
        $("#structure .number").each(function(index){
            if(index == nextSlide){
                $(this).addClass("active");
            }
            else{
                $(this).removeClass("active");
            }
        })
    });

    $("#structure .number").click(function(){
        var index = $("#structure .number").index($(this));
        var toSlide = "#structure #slick-slide-control1"+index;

        $(toSlide).click()
    })


// Icons slider on mobile
    if (screen.width <767){
        $(".home-advantages .advantages-wrap").addClass("slick-slider");
    }

// Get-Started drop down

    $(".getstarted-info .more-btn").click(function(){
        if($(this).hasClass("active")){
            $(".getstarted-info .more-btn").removeClass("active")
        }
        else{
            $(".getstarted-info .more-btn").removeClass("active")
            $(this).addClass("active");
        }
        const index = $(".getstarted-info .more-btn").index($(this));
        $(".getstarted-info .container-bottom").each(function(i){
            if (i==index){
                if ($(this).hasClass("active")){
                    $(this).removeClass("active");
                }
                else{
                    $(this).addClass("active");
                }
            }
            else{
                $(this).removeClass("active");
            }
        })

    })

// Custom Section - products
    $(".shopify-section--custom-products select").change(function(){
        $(this).children("option:selected").each(function(){
            var price = $(this).attr("price");
            var compare = $(this).attr("compare_at_price");
            if (price != compare ){
              $(this).parents(".purchase").find(".price-ui p.compare-at-price").text(compare);
            }
            else {
              $(this).parents(".purchase").find(".price-ui p.compare-at-price").text("");
            }
            $(this).parents(".purchase").find(".price-ui span.price").text(price);
        });
      });

// Home Section - products 
    $(".product_form select").change(function(){
        $(this).children("option:selected").each(function(){
            var price = $(this).attr("price");
            console.log(price);
            $(this).parents("form").find("button").attr('data-value', price);
            $(this).parents("form").find("button").attr('data-variant', $(this).attr("value"));

            // $(this).parents(".purchase").find("button:after").css("content", price);
        });
    });

// Product page - product price
    

// Sezzle button
    $(".top-bar .cart_content form .sezzle-checkout-button").addClass("global-button");
    $(".shopify-section--cart-template form .sezzle-checkout-button").addClass("global-button")

    
// holiday-gift-guide page promo click
    $(".gift-bundle .image_caption").click(function(){
        if($(this).hasClass("active")){
            $(this).removeClass("active");

        }
        else{
            $(this).addClass("active");
        }
        if($(this).parents(".image-with-text-container").hasClass("is-collapsed-on-mobile") && screen.width <767){
            $(this).parents(".image-with-text-container").removeClass("is-collapsed-on-mobile").addClass("is-open-on-mobile")
        }
        else if ($(this).parents(".image-with-text-container").hasClass("is-open-on-mobile") && screen.width <767) {
            $(this).parents(".image-with-text-container").removeClass("is-open-on-mobile").addClass("is-collapsed-on-mobile")
        }
    })

// Add to cart track
    $(".shopify-product-form .add_to_cart").click(function(){
        const productQuantity = $("#quantity").val();
        const productId = $(".product_form").attr("data-product-title");
        const productName = $(".product_form").attr("data-product-title");
        const productPrice = $(this).attr("data-value");
        const variantId = $(this).attr("data-variant");
        twq('event', 'tw-od4ym-od7fk', {
            value: 1,
            currency: $("body").attr("data-shop-currency"),
            contents: [
            {
                content_type: "Add to cart",
                content_id: productId,
                content_name: productName,
                content_price: productPrice,
                num_items: productQuantity,
                content_group_id: null
            }
            ], 
            conversion_id: null, 
            email_address: '' 
        });
        window.attentive.analytics.addToCart(
            {
                items:[
                    {
                        productId: productId,
                        productVariantId: variantId,
                        name: productName,
                        category: 'food',
                        price: {
                          value: productPrice,
                          currency: 'USD',
                        },
                        quantity: productQuantity,
                    }
                ],
                cart: {
                    cartId: 'cart-1',
                    cartCoupon: '123',
                },
                user: {
                    phone: '212-111-3123'
                }
            }
        )
    })
    


// Initiate Checkout
    $("button[name='checkout']").click(function(){
        twq('event', 'tw-od4ym-od7fw', {
            value: 1,
            currency: $("body").attr("data-shop-currency"), 
            contents: [ 
                {
                content_type: "Initiate checkout",
                content_id: null,
                content_name: null,
                content_price: $(this).parents("form").find(".cart_subtotal .money")[0].innerHTML.trim(),
                num_items: null,
                content_group_id: null
                }], 
            conversion_id: null, 
            email_address: '' 
        });
    })

// Investors page
    $(".investors-link .email").click(function(){
        document.getElementById("shopify-section-template--16687282585858__3dd3f7ea-4668-4931-81ad-283553b3e37a").scrollIntoView({behavior: 'smooth'});
    })

    $(".investors-link .contact").click(function(){
        document.getElementById("shopify-section-template--16687282585858__3dd3f7ea-4668-4931-81ad-283553b3e37a").scrollIntoView({behavior: 'smooth'});
    })